import axios from 'axios'
import { Toast } from 'vant'
import Vue from 'vue'
import { decodeObject, encode, encodeObject } from '@/utils/mapping'

const vueInstance = Vue.prototype
const enabled = process.env.VUE_APP_MAPPING_ENABLED === 'true'

const Axios = axios.create({
  baseURL: enabled ? process.env.VUE_APP_BASE_URL_MAP : process.env.VUE_APP_BASE_URL,
  timeout: 0
})

Axios.interceptors.request.use(config => {
  config.headers['x-auth-token'] = localStorage.getItem('token')
  config.headers['x-version'] = localStorage.getItem('version')
  config.headers['x-package-name'] = localStorage.getItem('packageName')

  // 编码headers
  if (config.headers) {
    config.headers = encodeObject(config.headers)
  }
  // 处理URL
  if (config.url) {
    const [path, queryString] = config.url.split('?')
    let finalUrl = encode(path)
    // 处理查询参数
    if (queryString) {
      const params = {}
      queryString.split('&').forEach(pair => {
        const [key, value] = pair.split('=')
        if (key) {
          const decodedKey = decodeURIComponent(key)
          params[decodedKey] = decodeURIComponent(value || '')
        }
      })
      const encodedParams = encodeObject(params)
      const newQueryString = Object.keys(encodedParams)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(encodedParams[key])}`)
        .join('&')
      finalUrl += '?' + newQueryString
    }
    config.url = finalUrl
  }
  // 编码请求数据 跳过 FormData
  if (config.data && !(config.data instanceof FormData)) {
    config.data = encodeObject(config.data)
  }
  // 编码请求参数
  if (config.params) {
    config.params = encodeObject(config.params)
  }
  return config
}, error => {
  return Promise.reject(error)
})

Axios.interceptors.response.use(response => {
  // 解码响应数据
  if (response.data) {
    response.data = decodeObject(response.data)
  }
  const code = response.data.code
  if (code === '-1') {
    // Toast(response.data.message)
    // 返回原生登录页
    setTimeout(
      () => {
        vueInstance.$javaNative(1)
      },
      1000
    )
  }
  if (code === '99' || code === '500') {
    Toast(response.data.message)
  }
  return response.data
}, error => {
  return Promise.reject(error)
})
export default Axios
